export default "__VITE_ASSET__SXkKaAlb__"